import { render, staticRenderFns } from "./ShopPayQrcode.vue?vue&type=template&id=816f1a9c&scoped=true"
import script from "./ShopPayQrcode.vue?vue&type=script&lang=js"
export * from "./ShopPayQrcode.vue?vue&type=script&lang=js"
import style0 from "./ShopPayQrcode.vue?vue&type=style&index=0&id=816f1a9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816f1a9c",
  null
  
)

export default component.exports